import React, { Fragment, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/Help-Desk-Components/Footer/Footer";
import HeaderBuga from "../../components/header6/Header6";

import icon3 from "../../images/hero/Palystore-qr.png";
import icon4 from "../../images/hero/Appstore-qr.png";
import mobileAppImg from "../../images/icon/Buga/buga-money-apps-iamges.png";

const DownloadApp = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <HeaderBuga />

        {/* ===== Page Title ===== */}
        <section style={heroStyles.section}>
  <div className="container">
    <div className="row justify-content-center text-center">
      <div className="col-lg-8 col-md-10 col-sm-12">

        

        <h1 className="mt-4" style={heroStyles.title}>
          Download Buga Money App
        </h1>

        

      </div>
    </div>
  </div>
</section>


        {/* ===== Download App Section ===== */}
        <section style={styles.section}>
          <div className="container">
            <div className="row align-items-center">
              {/* LEFT CONTENT */}
              <div className="col-lg-5 mb-5 mb-lg-0">
                <span style={styles.badge}>AVAILABLE NOW</span>

                <h3 style={styles.mainTitle}>
                  Send Money Globally <br /> With Confidence
                </h3>

                <p style={styles.description}>
                  Scan the QR code to download the Buga Money app and send money
                  to Nigeria instantly with ZERO fees and the best exchange
                  rates.
                </p>

                <div className="row mt-4">
                  <div className="col-6 d-flex justify-content-center">
                    <div style={styles.qrCard}>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.org.bugamoney"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                      >
                        <img
                          src={icon3}
                          alt="Google Play QR"
                          style={styles.qrImage}
                        />
                        <p style={styles.storeText}>Google Play</p>
                      </a>
                    </div>
                  </div>

                  <div className="col-6 d-flex justify-content-center">
                    <div style={styles.qrCard}>
                      <a
                        href="https://apps.apple.com/in/app/buga-money-transfer/id6749626385"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                      >
                        <img
                          src={icon4}
                          alt="App Store QR"
                          style={styles.qrImage}
                        />
                        <p style={styles.storeText}>App Store</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT – MOBILE IMAGE */}
              <div className="col-lg-7 text-center">
                <div style={styles.phoneWrapper}>
                  <img
                    src={mobileAppImg}
                    alt="Buga Money App UI"
                    className="img-fluid"
                    style={styles.mobileImage}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default DownloadApp;

/* ================= INTERNAL STYLES ================= */

const styles = {
  section: {
    padding: "80px 15px",
    background: "radial-gradient(circle at top right, #fff7db, #f9fafc 60%)",
  },

  badge: {
    display: "inline-block",
    padding: "6px 14px",
    background: "#f9bb1d",
    color: "#111",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "20px",
    marginBottom: "18px",
  },

  mainTitle: {
    fontSize: "34px",
    fontWeight: "700",
    lineHeight: "1.3",
    color: "#111",
    marginBottom: "15px",
  },

  description: {
    fontSize: "16px",
    color: "#555",
    maxWidth: "420px",
  },

  /* ✅ QR CARD WITH YELLOW GRADIENT BORDER */
  qrCard: {
    width: "220px",
    borderRadius: "22px",
    padding: "24px",
    background: "#fff",

    border: "2px solid transparent",
    backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      linear-gradient(135deg, #f9bb1d, #ffd86b, #f9bb1d)
    `,
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",

    boxShadow: "0 18px 35px rgba(249,187,29,0.25)",
    textAlign: "center",
    transition: "all .3s ease",
  },

  qrImage: {
    width: "150px",
    height: "150px",
    objectFit: "contain",
    marginBottom: "10px",
  },

  storeText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#111",
    margin: 0,
  },

  link: {
    textDecoration: "none",
    color: "inherit",
  },

  phoneWrapper: {
    position: "relative",
    display: "inline-block",
  },

  mobileImage: {
    maxWidth: "520px",
    width: "100%",
    filter: "drop-shadow(0 40px 70px rgba(0,0,0,0.35))",
  },
};
const heroStyles = {
  section: {
    padding: "130px 15px 20px",
    background: "linear-gradient(135deg, #fff7db 0%, #f9fafc 65%)",
  },

  badge: {
    display: "inline-block",
    padding: "7px 18px",
    backgroundColor: "#f9bb1d",
    color: "#111",
    fontSize: "12px",
    fontWeight: "700",
    borderRadius: "30px",
    marginBottom: "22px",
    letterSpacing: "0.6px",
  },

  title: {
    fontSize: "44px",
    fontWeight: "800",
    lineHeight: "1.15",
    color: "#111",
    marginBottom: "18px",
  },

  subtitle: {
    fontSize: "17px",
    color: "#555",
    maxWidth: "540px",
    margin: "0 auto",
    lineHeight: "1.6",
  },
};

